<script>
    import {navigateTo, PAGE_ID} from "../stores/router";
    import {selectPerson, fullNameFromRawPerson} from "../stores/misc";
    import {people} from "../stores/people";
    import Label from "./Label.svelte";

    export let related_people = [];
    export let return_page_id = PAGE_ID.DASHBOARD;

</script>


{#if related_people.length > 0}
    <ul role="list" class="mt-2 divide-y divide-gray-200 rounded-md border border-gray-200">
        {#each related_people as person (person.id)}
            <li>
                <a on:click|preventDefault={() => {
                                    selectPerson(person.id);
                                    navigateTo(PAGE_ID.VIEW_PERSON, return_page_id);
                                }} href="/" class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                    <div class="flex w-0 flex-1 items-center">
                        <Label type="person"></Label>
                        <span class="ml-2 w-0 flex-1 truncate">{fullNameFromRawPerson($people.lookup[person.id])}</span>
                    </div>
                </a>
            </li>
        {/each}
    </ul>
{/if}


<style></style>